import { Table, message } from "antd";

import _ from "lodash";
import { useState } from "react";
import { deleteCategory, getAllCategories } from "../../helpers/api";
import { Chip, Modal, Select, Badge } from "@mantine/core";
import smallTalk from "smalltalk";
import { useQuery } from "react-query";
import NewCategoryForm from "./components/new-category";
import EditCategoryForm from "./components/edit-category";
import { getUser } from "../../helpers/auth";

const CategoriesPage = () => {
  const user = getUser();
  // states
  const [filteredData, setFilteredData] = useState([]);
  const [modal, setModal] = useState({
    isOpen: false,
    title: "",
    content: null,
    // zIndex
  });

  // queries
  const {
    data: categories,
    isFetching,
    refetch,
  } = useQuery({
    queryFn: () => getAllCategories(),
    queryKey: ["categories"],
    onSuccess: (data) => setFilteredData(data),
  });

  // handlers
  const handleReset = () => setFilteredData(categories);

  const handleDelete = (id) => {
    smallTalk
      .confirm("Delete Category", "This action is irreversible. Continue?", {
        buttons: {
          ok: "YES",
          cancel: "NO",
        },
      })
      .then(() => {
        message.loading("deleting...");
        deleteCategory(id).then((res) => {
          message.success("done!");
          refetch();
        });
      })
      .catch((ex) => message.error("no action taken"));
  };

  // categories table
  const columns = [
    {
      title: "Title",
      sorter: (a, b) => a?.title > b?.title,
      sortDirections: ["descend", "ascend"],
      render: (text, record, index) => <span>{record?.title}</span>,
    },

    {
      title: "Type",
      width: 130,
      sorter: (a, b) => a?.type > b?.type,
      sortDirections: ["descend", "ascend"],
      render: (text, record, index) => (
        <Badge
          color={
            record?.type === "expense"
              ? "red"
              : record?.type === "income"
              ? "green"
              : record?.type === "service"
              ? "blue"
              : "gray"
          }
          variant="light">
          {record?.type?.charAt(0).toUpperCase() + record?.type?.slice(1)}
        </Badge>
      ),
    },
    // {
    //   title: "Description",
    //   width: 200,
    //   render: (text, record, index) => (
    //     <span className="text-muted">
    //       {record?.description || "No description"}
    //     </span>
    //   ),
    // },
    {
      title: "",
      width: 170,
      render: (text, record, index) => (
        <>
          <button
            className="button app-btn is-ghost "
            onClick={() =>
              setModal({
                title: "View/Edit Category",
                content: (
                  <EditCategoryForm onSuccess={refetch} id={record.id} />
                ),
                isOpen: true,
              })
            }>
            <span className="bi bi-eye me-1"></span>
            View
          </button>
          <button
            className="button app-btn is-light text-danger is-ghost"
            onClick={() => {
              handleDelete(record.id);
            }}>
            <span className="bi bi-trash"></span>
          </button>
        </>
      ),
    },
  ];

  return (
    <>
      <Modal
        onClose={() => setModal({ ...modal, isOpen: false })}
        opened={modal.isOpen}
        title={modal.title}
        zIndex={50}>
        {modal.content}
      </Modal>
      <div className="d-flex justify-content-between">
        <div className="d-flex mb-3">
          <button
            className={`button app-btn btn-prim me-3`}
            onClick={() =>
              setModal({
                title: "Add Category",
                content: <NewCategoryForm onSuccess={refetch} />,
                isOpen: true,
              })
            }>
            <span className="bi bi-plus-circle me-2"></span>
            Add Category
          </button>
        </div>

        <div div className="d-flex">
          <div>
            <Badge color="teal" variant="outline" size="lg" className="me-2">
              {filteredData?.length || 0}
            </Badge>
            Categories
          </div>
          <button
            onClick={handleReset}
            className="button app-btn btn-text ms-2 d-flex align-items-center">
            <span className="bi bi-arrow-clockwise me-2"></span>
            <span className="d-none d-md-inline"> Reset filters</span>
          </button>
          <button className="button app-btn" onClick={() => refetch()}>
            <span className="bi bi-cycle"></span>
            <span className="d-none d-md-inline">Refresh</span>
          </button>
        </div>
      </div>

      {/* Search and Filters */}
      <div className="row my-3">
        <div className="col-md-6 col-12 mb-3">
          <div className="field">
            <input
              className="input"
              onChange={(e) =>
                setFilteredData(
                  categories?.filter(
                    (c) =>
                      c?.title
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase()) ||
                      c?.description
                        ?.toLowerCase()
                        .includes(e.target.value.toLowerCase())
                  )
                )
              }
              title="search here"
              placeholder="Search by title or description"
            />
          </div>
        </div>
        <div className="col-md-3 col-6 mb-3">
          <select
            className="input"
            onChange={(e) => {
              if (e.target.value === "") {
                setFilteredData(categories);
              } else {
                setFilteredData(
                  categories?.filter((c) => c.type === e.target.value)
                );
              }
            }}>
            <option value="">All Types</option>
            <option value="expense">Expense</option>
            {/* <option value="income">Income</option> */}
            <option value="service">Service</option>
            {/* <option value="support">Support</option> */}
          </select>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Table
            columns={columns}
            // bordered
            className="border"
            dataSource={filteredData}
            rowKey={(record) => record.id}
            loading={isFetching}
          />
        </div>
      </div>
    </>
  );
};

export { CategoriesPage };
